import { useFetchLearnedPinyinSounds } from "@-/dev.improve.haniverse.lib.cards.user-card.grapheme.pronunciation.read";
import { logger } from "@-/dev.improve.haniverse.lib.logger";
import {
  isPinyinLearned,
  withLearnedPinyin,
} from "@-/dev.improve.haniverse.lib.morpheme.grapheme.pinyin";

export type IsPinyinLearned = (toneNumbersPinyin: string) => boolean;

/**
 * For a reveal's auto-play: reads the pinyin sounds the learner has learned, and resolves whether
 * they can read a reading — every initial, final and tone of it learned from a reading in study, or
 * taught by the card on screen (`taughtPinyinList`, a lesson's introduced readings). A reading the
 * learner cannot read yet is not spoken, so its sounds are first heard with the lesson that teaches
 * them. When the learner's cards cannot be read, no reading counts and the reveal stays silent.
 */
export function useFetchIsPinyinLearned(): (
  taughtPinyinList?: readonly string[],
) => Promise<IsPinyinLearned> {
  const fetchLearnedPinyinSounds = useFetchLearnedPinyinSounds();
  return async (taughtPinyinList = []) => {
    try {
      const learned = withLearnedPinyin(await fetchLearnedPinyinSounds(), taughtPinyinList);
      return (toneNumbersPinyin) => isPinyinLearned(toneNumbersPinyin, learned);
    } catch (error) {
      logger(import.meta.location).error("Could not read the learned pinyin sounds", error);
      return () => false;
    }
  };
}
